import { Mist } from '@app/shared/models/mist/mist.model';
import { Location } from '@app/shared/models/location.model';

export class MistLocation {
    public mists: Mist[];
    public location: Location;
}